var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResultsTemplate',{attrs:{"title":"Map"},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('Map',{on:{"add:city":function($event){return _vm.$emit('add:city', $event)}}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }